import { createContext, ReactNode, useState } from 'react';

// types
export type SelectedMenuContextType = {
  selectedMenuId: string | null;
  setSelectedMenuId: (id: string | null) => void;
};

export const SelectedMenuContext = createContext<SelectedMenuContextType | undefined>(undefined);

// ==============================|| SELECTED MENU PROVIDER ||============================== //

export function SelectedMenuProvider({ children }: { children: ReactNode }) {
  const [selectedMenuId, setSelectedMenuId] = useState<string | null>(null);

  const value: SelectedMenuContextType = {
    selectedMenuId,
    setSelectedMenuId
  };

  return <SelectedMenuContext.Provider value={value}>{children}</SelectedMenuContext.Provider>;
}
